export default {
  getDate(i) { //获取本周日期，输出今天到周日的日期
    let time = new Date();
    let day = time.getDay(),
      date = time.getDate(),
      month = time.getMonth(),
      nowYear = time.getYear();
    let str = new Date(nowYear, month, date + i - day);
    let xxx = this.formatDate(str)
    console.log(xxx)
    // return this.formatDate(str)
  },
  formatDate(date) {
    // let mymonth = date.getMonth()+1;
    let myweekday = date.getDate();
    let myDay = date.getDay() + 2;
    // if(mymonth < 10){
    //     mymonth = "0" + mymonth;
    // }
    if (myweekday < 10) {
      myweekday = "0" + myweekday;
    }
    if (myDay > 7) {
      myDay = 1
    }
    let str = this.transferWeek(myDay)
    return (myweekday + '日 周' + str);
  },
  transferWeek(data) { //将星期数的阿拉伯数字转换成语文数字
    switch (data) {
      case 1:
        return '一';
        break;
      case 2:
        return '二';
        break;
      case 3:
        return '三';
        break;
      case 4:
        return '四';
        break;
      case 5:
        return '五';
        break;
      case 6:
        return '六';
        break;
      case 7:
        return '日';
        break;
      case 0:
        return '日';
        break;
    }
  },
  verificationID(tel) { //正则验证电话号码
    let reg = /^1\d{10}$/;
    if (!(reg.test(tel))) {
      return false;
    } else {
      return true;
    }
  },
  getNewObj(data) {
    //解决vue赋值指向统一源文件导致的双向绑定问题
    let _obj = {};
    _obj = JSON.parse(JSON.stringify(data)); //data是父组件传递的对象
    return _obj;
  },
  openApp(downloadUrlList,parrmsUrl) {

    var openIframe = this.createIframe();
    var u = navigator.userAgent;
    var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var localUrl = "";
    if(isIos){      
      localUrl = parrmsUrl ? "mseduOnline://study.mshiedu.com?" +  parrmsUrl : "mseduOnline://study.mshiedu.com?"+ window.location.href;  
    }else{
      localUrl = parrmsUrl ? "poko://study.mshiedu.com" +  parrmsUrl : "poko://study.mshiedu.com?shareUrl=" + window.location.href;
    }    

    var isChrome = window.navigator.userAgent.indexOf("Chrome") !== -1;
    if (isIos) {
      //判断是否是ios,具体的判断函数自行百度
      window.location.href = localUrl;
      var loadDateTime = Date.now();
      
      setTimeout(function () {
          window.location.href =
            downloadUrlList[0].downloadUrl;//苹果下载地址
      }, 3000);
    } else if (isAndroid) {
      //判断是否是android，具体的判断函数自行百度
      if (isChrome) {
        //chrome浏览器用iframe打不开得直接去打开，算一个坑
        window.location.href = localUrl;
      } else {
        //抛出你的scheme
        openIframe.src = localUrl;
      }
      
      setTimeout(function () {
        window.location.href = downloadUrlList[1].downloadUrl;// ("你的安卓下载地址");                 
      }, 3000);
    }
  },
  createIframe() {
    var iframe;
    return function () {
      if (iframe) {
        return iframe;
      } else {
        iframe = document.createElement("iframe");
        iframe.style.display = "none";
        document.body.appendChild(iframe);
        return iframe;
      }
    };
  },
  isIOS9() {/*判断是否是ios9以上*/
    //获取固件版本
    var getOsv = function () {
      var reg = /OS ((\d+_?){2,3})\s/;
      if (navigator.userAgent.match(/iPad/i) || navigator.platform.match(/iPad/i) || navigator.userAgent.match(/iP(hone|od)/i) || navigator.platform.match(/iP(hone|od)/i)) {
        var osv = reg.exec(navigator.userAgent);
        if (osv.length > 0) {
          return osv[0].replace('OS', '').replace('os', '').replace(/\s+/g, '').replace(/_/g, '.');
        }
      }
      return '';
    };
    var osv = getOsv();
    var osvArr = osv.split('.');
    //初始化显示ios9引导
    if (osvArr && osvArr.length > 0) {
      if (parseInt(osvArr[0]) >= 9) {
        return true
      }
    }
    return false
  },
  isWeiXin() {//判断是否是微信浏览器
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  },
  isIos(){
    let u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  },  
  sessionStorage: {
    storage: window.sessionStorage,
    getItem: function (key) {
      let value = this.storage.getItem(key);
      if (value === null) {
        return false;
      }
      if (value && value.substring(0, 1) === "{" || value.substring(0, 1) == "[") {  // 判断字符串是否是对象或则数组结构
        value = JSON.parse(value);  //将字符串转成json
      }
      return value
    },
    setItem: function (key, value) {
      if (this.getType(value) === 'Object' || this.getType(value) === 'Array') {
        value = JSON.stringify(value);
      }
      this.storage.setItem(key, value);
    },
    // 删除项
    removeItem: function (key) {
      this.getItem(key) && this.storage.removeItem(key);
    },
    //  清空
    clear: function () {
      this.storage.clear(); // 清空本地存储
    },
    getType: (object) => {
      /**
       * 方法来源：prototype.js
       * getType(5); // => "Number"
       * getType({}); // => "Object"
       * getType(/foo/); // => "RegExp"
       * getType(''); // => "String"
       * getType(true); // => "Boolean"
       * getType([]); // => "Array"
       * getType(undefined); // => "Window"
       * getType(Element); // => "Constructor"
       **/
      return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
    },
  },  
  setTitle(title){
    document.title = title;
  },
  randomString(len) {//生成随机字符串
    　　len = len || 32;
    　　var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    　　var maxPos = $chars.length;
    　　var pwd = '';
    　　for (i = 0; i < len; i++) {
    　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    　　}
    　　return pwd;
  },
   // APP下载资料
   appDownLoadFile(url,name){
    let data = {
      url:url,
      name:name,
    }
    if (this.isIos()) {
      if(window.JXBJSBridge){
        window.JXBJSBridge.call({
          target: "WKFunction",
          action: "downloadXqdFile",
          data: data,
          callback: {
          }
        });
      }
    } else {
      if (window.Android && window.Android.downloadXqdFile) {
        window.Android.downloadXqdFile(JSON.stringify(data));
      } else if (window.downloadXqdFile) {
        window.downloadXqdFile.jsMethod(JSON.stringify(data));
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/utils/common.js